export default __webpack_public_path__ + "static/1603-1d440192713c448bd99413878933aa9f.gif";